import template from './contact-group-warnings.html';

const component = {
    template,
    bindings: {
        contactGroups: '<',
        actionType: '<',
        computedWarnings: '<',
        onToggleExpand: '&',
        onIsExpanded: '&',
        onGetDisplayName: '&',
        onSaveAll: '&',
    },
};

export default component;
